import { ActionableAlert } from './ActionableAlert';
import type { ActionableMessage } from './ActionableMessages';

interface Props {
  readonly errors: readonly ActionableMessage[];
  readonly title?: string;
}

// The refusals of a screen, listed in a single alert: nothing without any.
export const ErrorsAlert = ({
  errors,
  title = 'À corriger',
}: Readonly<Props>) => (
  <ActionableAlert items={errors} severity="error" title={title} />
);
